export default "__VITE_ASSET__972065cb__"